
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLeaf as ObiLeafElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-leaf.js';
 
 
 

 
 export const ObiLeaf = createComponent({
   react: React,
   tagName: 'obi-leaf',
   elementClass: ObiLeafElement,
   events: {
     
   }
  });
 
 